import AdminWaitlistRow from "./AdminWaitlistRow";

const COLUMNS = ["Pos", "Email", "Idea", "Refs", "Referred by", "Status", "Actions"];

export default function AdminWaitlistTable({ rows, filtered, onCopy, onInvite }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="admin-waitlist-table">
        <thead className="text-left text-white/60 font-mono text-[10px] uppercase tracking-widest">
          <tr className="border-b border-white/10">
            {COLUMNS.map((c) => (
              <th key={c} className="py-3 pr-4">{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!rows && (
            <tr><td colSpan={COLUMNS.length} className="py-8 text-center text-white/50">Loading…</td></tr>
          )}
          {rows && filtered.length === 0 && (
            <tr><td colSpan={COLUMNS.length} className="py-8 text-center text-white/50">No signups yet</td></tr>
          )}
          {filtered.map((r) => (
            <AdminWaitlistRow key={r.email} row={r} onCopy={onCopy} onInvite={onInvite} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
